import { render, staticRenderFns } from "./WidgetProjectTopics.vue?vue&type=template&id=7073c4ca&scoped=true"
import script from "./WidgetProjectTopics.vue?vue&type=script&lang=js"
export * from "./WidgetProjectTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073c4ca",
  null
  
)

export default component.exports